interface IconWizardModeProps {
  className?: string;
}

export const IconWizardMode = ({ className }: IconWizardModeProps) => (
  <svg
    className={className}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M4 20L14.5 9.5' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
    <path
      d='M15.5 8.5L16.5 7.5C17.3 6.7 18.6 6.7 19.4 7.5L20.5 8.6C21.3 9.4 21.3 10.7 20.5 11.5L19.5 12.5'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8 4L8.6 2.5L10.1 2L8.6 1.5L8 0L7.4 1.5L5.9 2L7.4 2.5L8 4Z'
      stroke='currentColor'
      strokeWidth='1.2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M3 10L3.4 9L4.4 8.6L3.4 8.2L3 7.2L2.6 8.2L1.6 8.6L2.6 9L3 10Z'
      stroke='currentColor'
      strokeWidth='1.2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
